var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupeeMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7955 4.74716L11.3438 6.24716H0.622159L1.06534 4.74716H11.7955ZM7.45739 18L0.758523 10.1335L0.741477 9.03409H3.6733C4.55966 9.03409 5.31534 8.90625 5.94034 8.65057C6.56534 8.3892 7.04261 8.00284 7.37216 7.49148C7.70739 6.98011 7.875 6.34659 7.875 5.59091C7.875 4.47727 7.52557 3.60227 6.8267 2.96591C6.13352 2.32386 5.1392 2.00284 3.84375 2.00284H0.622159L1.06534 0.545454H3.84375C5.09375 0.545454 6.1392 0.761363 6.98011 1.19318C7.8267 1.625 8.46307 2.22159 8.8892 2.98295C9.32102 3.73864 9.53693 4.60795 9.53693 5.59091C9.53693 6.51136 9.32955 7.34091 8.91477 8.07955C8.50568 8.8125 7.87216 9.39489 7.0142 9.8267C6.16193 10.2528 5.07386 10.4659 3.75 10.4659H3.13636L9.44318 17.8722V18H7.45739ZM11.8551 0.545454L11.4119 2.04545L2.37784 2.00284L2.78693 0.545454H11.8551Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeMedium);
export default __webpack_public_path__ + "static/media/rupee-medium.891040d14dc41df368e7734b012aa396.svg";
export { ForwardRef as ReactComponent };